import * as React from "react"
import { Button } from "../ui/button"
import { Input } from "../ui/input"
import { Label } from "../ui/label"

import { FormDataProps, BusinessTypesProps } from "../CalculatorTypes"

export interface Step3Props {
    formData: FormDataProps
    onNext: ({
        firstName,
        lastName,
        email,
        telnumber,
        projectName,
    }: {
        firstName: string
        lastName: string
        email: string
        telnumber: string
        projectName: string
    }) => void
}

export default function Step3({ formData, onNext }: Step3Props) {
    const [firstName, setFirstName] = React.useState(formData?.firstName || "")
    const [lastName, setLastName] = React.useState(formData?.lastName || "")
    const [email, setEmail] = React.useState(formData?.email || "")
    const [telnumber, setTelnumber] = React.useState(formData?.telnumber || "")
    const [projectName, setProjectName] = React.useState(
        formData?.projectName || ""
    )

    const [errorEmail, setErrorEmail] = React.useState("")
    const [errorTel, setErrorTel] = React.useState("")

    /* ── Validatoren ─────────────────────────────────────────── */
    const isEmail = (v: string) => /^[\w.+-]+@[\w-]+\.[\w.-]+$/.test(v.trim())
    const isTel = (v: string) => /^[+0-9]*$/.test(v.trim()) && v.trim().length >= 5

    /* ── Handler ─────────────────────────────────────────────── */
    const handleEmail = (e: React.ChangeEvent<HTMLInputElement> | string) => {
        const val = typeof e === "string" ? e : e.target.value
        setEmail(val)
        setErrorEmail(isEmail(val) ? "" : "Indirizzo e-mail non valido")
    }

    const handleTel = (val: string) => {
        setTelnumber(val)
        setErrorTel(isTel(val) ? "" : "Solo numeri e «+»")
    }

    const allValid =
        firstName.trim() &&
        lastName.trim() &&
        email.trim() &&
        !errorEmail &&
        telnumber.trim() &&
        !errorTel &&
        projectName.trim()

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        if (!allValid) return
        onNext?.({
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            email: email.trim(),
            telnumber: telnumber.trim(),
            projectName: projectName.trim(),
        })
    }

    /* ── UI ──────────────────────────────────────────────────── */
    return (
        <form
            onSubmit={handleSubmit}
            className="step-shadow step3 max-w-md w-full mx-auto p-3 lg:p-6 sm:p-3 space-y-3 rounded-2xl flex flex-col items-center justify-center"
            style={{
                maxWidth: "600px",
            }}
        >
            <h3 className="text-xl font-bold mb-4 text-center poppins-font">
                Lasciaci l' email ti mandiamo il risultato.
            </h3>

            <div className="space-y-2.5 mb-4 mt-6">
                <Label htmlFor="email" className="calculator-text font-light">
                    Inserisci il tuo indirizzo e-mail
                </Label>
                <Input
                    id="email"
                    type="email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={handleEmail}
                    className="calculator-text font-light"
                    required
                />
                {errorEmail && (
                    <p className="text-red-600 text-sm">{errorEmail}</p>
                )}
            </div>

            <div className="flex flex-row  split50 justify-between mb-4">
                {/* Vorname */}
                <div className="space-y-2.5 input-container mb-2">
                    <Label
                        htmlFor="firstName"
                        className="calculator-text font-light"
                    >
                        Nome
                    </Label>
                    <Input
                        id="firstName"
                        value={firstName}
                        placeholder="Mario"
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                        className="calculator-text font-light"
                    />
                </div>

                {/* Nachname */}
                <div className="space-y-2.5 input-container">
                    <Label
                        htmlFor="lastName"
                        className="calculator-text font-light"
                    >
                        Cognome
                    </Label>
                    <Input
                        id="lastName"
                        value={lastName}
                        placeholder="Rossi"
                        onChange={(e) => setLastName(e.target.value)}
                        required
                        className="calculator-text font-light"
                    />
                </div>
            </div>

            {/* Telefonnummer */}
            <div className="space-y-2.5 mb-4">
                <Label htmlFor="tel" className="calculator-text font-light">
                    Numero di telefono
                </Label>
                <Input
                    id="tel"
                    type="tel"
                    placeholder="+390123456789"
                    value={telnumber}
                    onChange={(e) => handleTel(e.target.value)}
                    className="calculator-text font-light"
                    required
                />
                {errorTel && <p className="text-red-600 text-sm">{errorTel}</p>}
            </div>

            {/* Projektnanme */}
            <div className="space-y-2.5 mb-4">
                <Label htmlFor="tel" className="calculator-text font-light">
                    Nome dell'azienda o progetto
                </Label>
                <Input
                    id="projectName"
                    value={projectName}
                    onChange={(e) => setProjectName(e.target.value)}
                    className="calculator-text font-light"
                    required
                />
            </div>

            {/* Button & Hinweis */}
            <Button
                type="submit"
                className="w-full mt-6 calculator-button-text font-medium"
                disabled={!email || !!errorEmail}
            >
                Avanti
            </Button>

            {/* Informativa privacy/marketing */}
            <p className="text-xs text-muted-foreground text-center italic">
                *Se continui consenti alla nostra privacy e comunicazione
                marketing.
            </p>
        </form>
    )
}
